import React from 'react'
import { FastField } from 'formik'
import { CustomTextField } from 'src/form'

import BillingCodes from 'src/participantHistory/intakeNote/BillingCodes'
import { Section, SubSection } from '../common/Section'

type DiagnosticSummaryFormProps = {
  viewOnly?: boolean
}

export function DiagnosticSummaryForm({ viewOnly }: DiagnosticSummaryFormProps) {
  return (
    <Section title="Diagnostic Summary and Case Conceptualization">
      <SubSection>
        <BillingCodes name="BILLING_CODE" viewOnly={viewOnly} />
        <FastField
          component={CustomTextField}
          name="CLINICAL_FORMULATION"
          label="Clinical formulation"
          fullWidth
          multiline
          minRows={4}
        />
        <FastField
          component={CustomTextField}
          name="CASE_CONCEPTUALIZATION"
          label="Case conceptualization"
          fullWidth
          multiline
          minRows={4}
        />
      </SubSection>
    </Section>
  )
}
